import { render } from "./MyCardTabText.vue?vue&type=template&id=690eec52&scoped=true&bindings={}"
import script from "./MyCardTabText.vue?vue&type=script&lang=ts"
export * from "./MyCardTabText.vue?vue&type=script&lang=ts"

import "./MyCardTabText.vue?vue&type=style&index=0&id=690eec52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-690eec52"

export default script